'use strict';

import React, { PureComponent } from 'react';
import bemit from 'Functions/bemit';
import { isTrue, num } from 'Shared/utilities';
const days_config = [{
  label: 'Lundi',
  value: 'monday'
}, {
  label: 'Mardi',
  value: 'tuesday'
}, {
  label: 'Mercredi',
  value: 'wednesday'
}, {
  label: 'Jeudi',
  value: 'thursday'
}, {
  label: 'Vendredi',
  value: 'friday'
}, {
  label: 'Samedi',
  value: 'saturday'
}, {
  label: 'Dimanche',
  value: 'sunday'
}];
const SHORT_WEEK = 'Lundi au vendredi';
const SHORT_WEEK_END = 'Samedi et dimanche';
const SHORT_FULLWEEK = 'Du lundi au dimanche';
function areSchedulesEqual({
  type,
  schedule,
  prev_schedule
}) {
  const open_fields = type === 'lounge' ? ['open'] : ['morning', 'afternoon'];
  const open__diff = open_fields.some(field => isTrue(schedule[field]) !== isTrue(prev_schedule[field]));
  if (open__diff) return false;
  if (type === 'lounge')
    // l'ouverture des deux jours diffère
    {
      return num(schedule.from, 0) === num(prev_schedule.from, 0) && num(schedule.to, 0) === num(prev_schedule.to, 0);
    }

  // chaque heure ouverte est identique pour tous les deux jours comparés
  return open_fields.every(function (field) {
    // on ne vérifie pas les horaires des créneaux fermés
    if (isTrue(schedule[field]) === false) return true;
    const from = schedule[field + '_from'];
    const to = schedule[field + '_to'];
    const prev_from = prev_schedule[field + '_from'];
    const prev_to = prev_schedule[field + '_to'];
    return num(from, 0) === num(prev_from, 0) && num(to, 0) === num(prev_to, 0);
  });
}
export default class FrontSpaceSchedule extends PureComponent {
  isWeekStable = () =>
  // tous les jours de la semaine ont les mêmes horaires
  {
    const component = this,
      props = this.props,
      state = this.state;
    return days_config.slice(0, -2).every(function (infos, i) {
      if (i === 0) return true; // égal à lui-même

      const prev_infos = days_config[i - 1];
      return areSchedulesEqual({
        type: props['space-type'],
        prev_schedule: props[prev_infos.value] || {},
        schedule: props[infos.value] || {}
      });
    });
  };
  isWeekEndStable = () => {
    const component = this,
      props = this.props,
      state = this.state;
    return areSchedulesEqual({
      type: props['space-type'],
      prev_schedule: props['saturday'] || {},
      schedule: props['sunday'] || {}
    });
  };
  isWeekSameAsWeekEnd = () => {
    const component = this,
      props = this.props,
      state = this.state;
    return areSchedulesEqual({
      type: props['space-type'],
      prev_schedule: props['monday'] || {},
      schedule: props['sunday'] || {}
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const modifiers = [].concat(props.bemit || []);
    const is__week_stable = component.isWeekStable();
    const is__weekend_stable = component.isWeekEndStable();
    const is__everyday_the_same = !is__week_stable || !is__weekend_stable ? false : component.isWeekSameAsWeekEnd();
    const config = is__everyday_the_same ? days_config.slice(0, 1) : is__week_stable && is__weekend_stable ? days_config.slice(4, 6) // vendredi et samedi
    : is__week_stable ? days_config.slice(4) // vendredi, samedi et dimanche
    : is__weekend_stable ? days_config.slice(0, 6) // tous les jours et w-e groupé
    : days_config.slice(0); // tous les jours

    const days = config.filter(function (infos) {
      const data = props[infos.value] || {};
      if (props['space-type'] === 'lounge') {
        return isTrue(data.open) && data.to && data.from ? true : false;
      }
      return isTrue(data.morning) || isTrue(data.afternoon);
    }).map(function (infos, i) {
      const data = props[infos.value] || {};
      const label = is__everyday_the_same ? SHORT_FULLWEEK : is__week_stable && is__weekend_stable ? i === 0 ? SHORT_WEEK : SHORT_WEEK_END : is__week_stable ? i === 0 ? SHORT_WEEK : infos.label : is__weekend_stable ? i < 5 ? infos.label : SHORT_WEEK_END : infos.label; // tous les jours

      if (props['space-type'] === 'lounge') {
        const from_label = data.from !== undefined && data.from !== '' ? 'De ' + num(data.from, 0) + 'h' : '-';
        const to_label = data.to !== undefined && data.to !== '' ? num(data.to, 0) + 'h' : '-';
        return /*#__PURE__*/React.createElement("div", {
          className: "c-front-space-schedule__day",
          key: infos.value
        }, /*#__PURE__*/React.createElement("div", {
          className: "c-front-space-schedule__day-label"
        }, label, "\xA0:"), /*#__PURE__*/React.createElement("div", {
          className: "c-front-space-schedule__from"
        }, from_label), from_label && from_label !== '-' && to_label && to_label !== '-' ? /*#__PURE__*/React.createElement("div", {
          className: "c-front-space-schedule__separator"
        }, "\xE0") : undefined, /*#__PURE__*/React.createElement("div", {
          className: "c-front-space-schedule__to"
        }, to_label));
      }
      const has__morning = !isTrue(data.morning) ? false : data.morning_from || data.morning_from === 0 ? true : false;
      const has__afternoon = !isTrue(data.afternoon) ? false : data.afternoon_from || data.afternoon_from === 0 ? true : false;
      return /*#__PURE__*/React.createElement("div", {
        className: "c-front-space-schedule__day",
        key: infos.value
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-front-space-schedule__day-label"
      }, label, "\xA0:"), /*#__PURE__*/React.createElement("div", {
        className: "c-front-space-schedule__from"
      }, has__morning ? 'Le matin de ' : undefined, has__morning ? num(data.morning_from, 0) + 'h' : undefined, has__morning ? ' à ' : undefined, has__morning ? num(data.morning_to, 0) + 'h' : undefined), has__morning && has__afternoon ? /*#__PURE__*/React.createElement("div", {
        className: "c-front-space-schedule__separator"
      }, "et") : undefined, /*#__PURE__*/React.createElement("div", {
        className: "c-front-space-schedule__to"
      }, has__afternoon ? 'l\'après-midi de ' : undefined, has__afternoon ? num(data.afternoon_from, 0) + 'h' : undefined, has__afternoon ? ' à ' : undefined, has__afternoon ? num(data.afternoon_to, 0) + 'h' : undefined));
    });
    let output = /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-space-schedule', modifiers)
    }, days);
    return output;
  }
}
